import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import SectionHeader from 'src/components/SectionHeader';
import Wrapper from 'src/components/util/Wrapper';

const AdminActivityDetailSection = ({ activityRows, columns }) => {
  return (
    <>
      <Wrapper
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: '1rem',
        }}
      >
        <SectionHeader title="Activity Detail" />
      </Wrapper>
      <Box sx={{ bgcolor: 'white', mb: '2rem' }}>
        {/* https://github.com/mui/mui-x/issues/4076 */}
        <DataGrid
          sx={{
            '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
              my: '1rem',
            },
          }}
          density="compact"
          autoHeight
          rowHeight={50}
          pageSize={10}
          rows={activityRows}
          columns={columns}
          rowsPerPageOptions={[10]}
        />
      </Box>
    </>
  );
};

export default AdminActivityDetailSection;
